import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from 'antd';
import logo from '../../assets/logo_transparent.png';
import ProfileMenu from './ProfileMenu';
import { BFMenu } from '../BFMenu/BFMenu';
import useNavItems from '../../hooks/useNavItems';
import './NavBar.css';

function NavBar() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const navItems = useNavItems();

    return (
        <Layout.Header className="bf-navbar">
            <button type="button" className="bf-navbar__logo-btn" onClick={() => navigate('/')}>
                <img src={logo} alt={t('login.logoAlt')} className="bf-navbar__logo" />
            </button>
            <BFMenu items={navItems} orientation="horizontal" className="bf-navbar__menu" />
            <ProfileMenu />
        </Layout.Header>
    );
}

export default NavBar;
